import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import cx from "classnames";
import {NavBar} from "ui/shared/components/NavBar";
import SignUp from '../components/SignUp';
import SignUpPro from '../components/SignUpPro';
import { Button } from "ui/shared/components/Buttons";
import { showEmailVerification } from 'data/account/actions/signInModal';


export default function SignUpContainer() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal)
    
    const tabs = [
        { name: `${t('account_button.consumer')}`, href: 'consumer', component: SignUp},
        { name: `${t('account_button.business')}`, href: 'business', component: SignUpPro },
    ]
    const [selectedTab, setSelectedTab] = useState(tabs[0].href)

    let changeTab = (tab) =>{
        setSelectedTab(tab)
    }

    return (
        <div className={cx('py-2 sm:px-10 overflow-y-scroll max-h-screen', {
            'bg-zinc-700' : selectedTab == 'business'
        })}>
            <div className="w-full flex justify-center my-6">
                <img className='w-1/3 max-w-[300px] min-w-[150px]' src={`/assets/img/logo/logo2020-${selectedTab === 'business' ? 'bicolore' : '500'}.png`} />
            </div>
            
            <div className="inner w-full h-full flex flex-col items-center gap-5 p-5">     
                <h2 className={cx("text-xl font-bold", {
                    'text-white' : selectedTab == 'business'
                })}>{t('account_button.creation_of_account')}</h2>

                <NavBar tabs={tabs} currentTab={selectedTab} onClick={changeTab}/>

                <div className='self-start flex items-center gap-2'>
                    <Button onClick={() => {dispatch(showEmailVerification(email))}} icon={"long-arrow-left"} className={"w-6 h-6 flex justify-center items-center bg-gray-200 hover:bg-gray-400 rounded-full"}/>
                    <p className={cx("", {
                        'text-white' : selectedTab == 'business'
                    })}>{email}</p>
                </div>

                {tabs.filter(tab=>tab.href == selectedTab).map(tab =>
                <div key={tab.href} className="mb-2" id={tab.href} >
                    <tab.component />
                </div>)}
            </div>
        </div>
    )
};